import React from "react";
import { Image } from "react-native";

const GenericInverter = require("./icons/inverters/generic_inverter.png");
const FroniusInverter = require("./icons/inverters/fronius_inverter.png");
const SmaSunnyBoy = require("./icons/inverters/sma_sunny_boy.png");
const SolarEdgeInverter = require("./icons/inverters/solar_edge_inverter.png");
const SolaxG2Inverter = require("./icons/inverters/solax_g2_inverter.png");
const SungrowSH5K = require("./icons/inverters/sungrow_sh5k.png");

const GenericBattery = require("./icons/batteries/generic_battery.png");
const BydBBox = require("./icons/batteries/byd_b_box.png");
const FroniusBattery = require("./icons/batteries/fronius_battery.png");
const GCLeKwBe = require("./icons/batteries/gcl_e_kwbe.png");
const LGResu10H7H = require("./icons/batteries/lg_resu_10H_or_7H.png");
const LGResu64 = require("./icons/batteries/lg_resu_64.png");
const Tesla = require("./icons/batteries/tesla.png");
const LGResu = require("./icons/batteries/lg_resu.png");
const PylonTechExtra2000 = require("./icons/batteries/pylontech_extra2000.png");

const SolarPanel = require("./icons/solar_panel.png");

const SamsungEssAio3 = require("./icons/all-in-one/samsung-ess-aio-3.png");
const OpalStorage = require("./icons/all-in-one/opal-storage.png");
const SolaxPowerStation = require("./icons/all-in-one/solax-power-station.png");

const STYLE = {
  width: 48,
  height: 48,
  resizeMode: "contain",
};

export const InverterIllustration = ({ uid, details }) => {
  if (!details) {
    return <Image style={STYLE} alt="" />;
  }

  let image;

  if (details.allInOne) {
    switch (uid) {
      case "samsung-ess-aio-3":
        image = SamsungEssAio3;
        break;
      case "opal-storage":
        image = OpalStorage;
        break;
      case "solax-power-station":
        image = SolaxPowerStation;
        break;
      default:
        image = GenericInverter;
    }
  } else {
    switch (details.model) {
      case "Fronius_Symo5.0":
      case "Fronius_Symo3.0":
      case "Fronius Galvo":
      case "Fronius Primo":
        image = FroniusInverter;
        break;
      case "SunnyBoyStorage_2.5":
        image = SmaSunnyBoy;
        break;
      case "SolarEdge SE5000":
      case "SolarEdge SE6000":
      case "SolarEdge SE7300":
      case "SolarEdge":
        image = SolarEdgeInverter;
        break;
      case "SolaxGen2":
        image = SolaxG2Inverter;
        break;
      case "Sungrow SH5KV10":
        image = SungrowSH5K;
        break;
      case "Magellan RES1-10-13.8":
      case "Samsung":
      default:
        image = GenericInverter;
    }
  }

  return <Image source={image} style={STYLE} alt="Inverter" />;
};

export const BatteryIllustration = ({ batteryDeets }) => {
  if (!batteryDeets) {
    return <Image style={STYLE} alt="" />;
  }

  let image;

  switch (batteryDeets.model) {
    case "BYD B-Box HV":
      image = BydBBox;
      break;
    case "Fronius Solar Battery":
      image = FroniusBattery;
      break;
    case "GCL E-KwBe":
      image = GCLeKwBe;
      break;
    case "LG HV":
      image = LGResu10H7H;
      break;
    case "LG RESU 6.4":
      image = LGResu64;
      break;
    case "LG RESU 9.6":
    case "LG RESU 12.8":
    case "LG RESU 48V":
      image = LGResu;
      break;
    case "Tesla_12.8":
    case "Tesla_6.4":
      image = Tesla;
      break;
    case "Pylontech":
      image = PylonTechExtra2000;
      break;
    case "LG EM048126P3Sx":
    case "Magellan RES1-10-13.8":
    case "Samsung_7.2kWh":
    case "Samsung_10.8kWh":
    case "Simpliphi Phi 3.4":
    default:
      image = GenericBattery;
  }

  return <Image source={image} style={STYLE} alt="Battery" />;
};

export const SolarIllustration = ({ pvConnected }) => {
  if (pvConnected) {
    return (
      <Image
        source={SolarPanel}
        style={{ width: 48, height: 48, resizeMode: "contain" }}
        alt="Solar"
      />
    );
  } else {
    return <Image style={STYLE} alt="" />;
  }
};



// WEBPACK FOOTER //
// ./src/containers/kit/ComponentIllustrations.js